import { ifClickable } from '@tock/shared/utils/touchUtils';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  analyticsEventLabel: string;
  children: JSX.Element | JSX.Element[] | string;
  onClick(): void;
}

export default class BannerAction extends BaseComponent<Props> {
  render() {
    const { analyticsEventLabel, children, onClick } = this.props;

    return (
      <p className="Banner-paragraph">
        <Anchor className="Banner-link" onClick={ifClickable(onClick, analyticsEventLabel)}>
          {children}
        </Anchor>
      </p>
    );
  }
}
